import React from 'react';
import { Code, Smartphone, Brain, Zap } from 'lucide-react';

const AboutSection = () => {
  const features = [
    {
      icon: Code,
      title: 'Web Development',
      description: 'Custom websites built with modern frameworks and best practices'
    },
    {
      icon: Smartphone,
      title: 'Mobile Apps',
      description: 'Native and cross-platform mobile applications that users love'
    },
    {
      icon: Brain,
      title: 'AI Integration',
      description: 'Intelligent systems powered by machine learning and AI'
    },
    {
      icon: Zap,
      title: 'Fast Delivery',
      description: 'Rapid development cycles without compromising quality'
    }
  ];

  return (
    <section id="about" className="relative py-24 overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="https://customer-assets.emergentagent.com/job_creative-studio-146/artifacts/n77nx60u_sanjuanventures_An_East_african_young_woman_with_long_neatly__f502b941-84b2-4328-9eae-70f3be4fc19b_0.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4 drop-shadow-lg">
            About <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Let There Be...</span>
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto drop-shadow-md">
            We're a creative technology studio that transform ambitious ideas into vivid masterpieces.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-md p-8 rounded-2xl border border-white/20 hover:border-violet-300 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-violet-100 to-pink-100 flex items-center justify-center mb-4">
                  <Icon className="w-7 h-7 text-violet-600" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2 drop-shadow-lg">{feature.title}</h3>
                <p className="text-white/90 drop-shadow-md">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;